import type * as Types from '../../../types/graphql';

import type { DocumentNode } from 'graphql';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';

export type SharrylandCherriesGqlQueryVariables = Types.Exact<{ [key: string]: never }>;

export type SharrylandCherriesGqlQuery = { __typename?: 'Query'; sharrylandCherries?: number | null };

export const SharrylandCherriesGqlDocument = /*#__PURE__*/ {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'sharrylandCherriesGQL' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sharrylandCherries' } }],
      },
    },
  ],
} as unknown as DocumentNode;

@Injectable({
  providedIn: 'root',
})
export class SharrylandCherriesGqlGQL extends Apollo.Query<
  SharrylandCherriesGqlQuery,
  SharrylandCherriesGqlQueryVariables
> {
  document = SharrylandCherriesGqlDocument;

  constructor(apollo: Apollo.Apollo) {
    super(apollo);
  }
}
